import PriceFilter from './price-filter';

export default PriceFilter;
